module.exports = __webpack_public_path__ + "img/no-data-list.6d1b2714.svg";